var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayCircleWhite = function SvgPlayCircleWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 14.6V9.4l2.809 2.6-2.809 2.6Zm.839-7.147a1.709 1.709 0 0 0-1.851-.307c-.61.266-.988.835-.988 1.484v6.74c0 .65.378 1.219.988 1.485.223.098.46.145.693.145.423 0 .838-.155 1.157-.451l3.642-3.37a1.61 1.61 0 0 0 .52-1.18c0-.442-.189-.872-.52-1.177l-3.641-3.37ZM12 20c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8Zm0-18C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2Z",
    fill: "#fff"
  })));
};
export default SvgPlayCircleWhite;